import { useNavigate } from "@/lib/useNav";
import { useChat } from "@/context/ChatContext";
import { ChatList } from "@/components/chat/ChatList";
import { cn } from "@/lib/utils";
import { X, Maximize2, MessageCircle } from "lucide-react";

export function ChatDrawer() {
  const { drawerOpen, setDrawerOpen, openWindow } = useChat();
  const navigate = useNavigate();

  const select = (chat) => {
    openWindow(chat.id, chat.name);
    setDrawerOpen(false);
  };

  return (
    <>
      {drawerOpen && <div className="fixed inset-0 z-40 bg-slate-900/20" onClick={() => setDrawerOpen(false)} data-testid="chat-drawer-overlay" />}
      <aside
        data-testid="chat-drawer"
        className={cn(
          "fixed right-0 top-0 z-[41] flex h-full w-full max-w-[400px] flex-col border-l border-slate-200 bg-white shadow-2xl transition-[transform,visibility] duration-200",
          drawerOpen ? "visible translate-x-0" : "invisible translate-x-full"
        )}
      >
        <div className="flex items-center gap-2 border-b border-slate-100 px-4 py-3">
          <MessageCircle className="h-5 w-5 text-sky-600" />
          <h2 className="font-heading text-lg font-bold text-slate-900">Chats</h2>
          <div className="ml-auto flex items-center gap-1">
            <button onClick={() => { setDrawerOpen(false); navigate("/chat"); }} title="Open full page" data-testid="chat-drawer-expand" className="rounded-lg p-1.5 text-slate-500 hover:bg-slate-100"><Maximize2 className="h-4 w-4" /></button>
            <button onClick={() => setDrawerOpen(false)} data-testid="chat-drawer-close" className="rounded-lg p-1.5 text-slate-500 hover:bg-slate-100"><X className="h-4 w-4" /></button>
          </div>
        </div>
        <div className="min-h-0 flex-1">
          <ChatList activeId={null} onSelect={select} paused={!drawerOpen} />
        </div>
      </aside>
    </>
  );
}
